import { Fragment } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { s } from '@/theme/tokens';
import { Link, Text } from '@/ui/primitives';
import { useBreadcrumbs } from './breadcrumbsContext';
import { Inline } from './Inline';
import type { Theme } from '@mui/material/styles';
import type { ReactElement } from 'react';

export const PageBreadcrumbs = (): ReactElement | null => {
  const { items, visible } = useBreadcrumbs();

  if (!visible || items.length === 0) return null;

  return (
    <Inline gap="sm" wrap="wrap">
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;
        const labelColor = isCurrent ? 'textPrimary' : 'textSecondary';
        const textSx = { fontSize: (theme: Theme) => theme.typography.subtitle1.fontSize };
        return (
          <Fragment key={`${item.label}-${index}`}>
            {index > 0 ? (
              <Text
                role="body"
                component="span"
                color="textSecondary"
                sx={[textSx, { marginX: s('xs') }]}
              >
                /
              </Text>
            ) : null}
            {item.href && !isCurrent ? (
              <Link component={RouterLink} to={item.href} underline="hover" color="inherit">
                <Text role="body" component="span" color={labelColor} sx={textSx}>
                  {item.label}
                </Text>
              </Link>
            ) : (
              <Text role="body" component="span" color={labelColor} sx={textSx}>
                {item.label}
              </Text>
            )}
          </Fragment>
        );
      })}
    </Inline>
  );
};
